import { LatLngBoundsLiteral } from 'ngx-google-places-autocomplete/objects/latLng';
import { LatLngBounds } from 'ngx-google-places-autocomplete/objects/latLngBounds';
import { ComponentRestrictions } from 'ngx-google-places-autocomplete/objects/options/componentRestrictions';
import { CreateLinkTokenRequest, ProjectActionPlanDetailItem, UserGroupAddRequest, UserIdentityVerificationInfo, UserIdentityVerificationRequest } from '../api-data/ng-openapi-gen-next/models';
import { InternalUserItem } from '../api-data/ng-openapi-gen-next/models';

export interface IDashboardWidget {}

export enum WidgetSize {
	small = 0,
	medium = 5,
	large = 10,
}
export enum EmployeePhotoSizeType {
	ORIGINAL = 1,
	MEDIUM = 2,
	SMALL = 3,
}
export class FileModel {
	file!: File;
	description!: string;
	fileName?: string;
	fileGUID?: string | null;
	pictureSizeType?: EmployeePhotoSizeType;
	createdByInternalUserGUID?: string | null;
}

export class FileReadOnlyModel {
	fileName!: string;
	file?: File;
	fileGUID?: string | null;
	createdByInternalUserGUID?: string | null;
}

export interface IEnvironment {
	production: boolean;
	apiRoot: string;
	nodeApiRoot: string;
	apiEnvironment: string;
	cognitoRegion: string;
	cognitoUserPoolId: string;
	cognitoAppClientId: string;
	cognitoDomain?: string;
	cognitoRedirectSignIn?: string;
	cognitoRedirectSignOut?: string;
	clientAppUri: string;
	extIdentityProviderRoot?: string;

	twilioAccountSid: string;
	twilioAuthToken: string;

	plaidVerificationTemplate: string;
	plaidEnv: string;
	consoleLogLevel: string;
}

export interface DialogButton {
	label: string;
	backgroundColor: string;
	textColor: string;
	func: () => void;
}

export interface GooglePlaceAutocompleteOptions {
	bounds?: LatLngBounds | LatLngBoundsLiteral;
	componentRestrictions?: ComponentRestrictions;
	placeIdOnly?: boolean;
	strictBounds?: boolean;
	types?: string[];
	type?: string;
	fields?: string[];

	/* List of countries which the autocomplete will be initialized with  */
	overridableCountries?: string[];
	options?: Options;
}

export interface Options {
	height: string | number | Function;
	width?: string | number | Function;
	cssClass?: string;
}

export interface SuccessResponse {
	data: any;
	totalCount: number;
	summary?: any[];
	groupCount?: number;
	customCount?: { [key: string]: any };
}

export interface PlaidUserConfig {
	user_Id: string;
}

export enum UserIdentityVerificationStatus {
	NotCreated = 'not_created',
	Active = 'active',
	Success = 'success',
	Failed = 'failed',
	Expired = 'expired',
	Canceled = 'canceled',
	PendingReview = 'pending_review',
}

/**
 * These status values are returned by Plaid API for identity verification status. It also reference all the status systemCode configured as part of PlaidStatusLookup table
 */
export enum PlaidIdentityVerificationStatus {
	PENDING_REVIEW = 'PENDING_REVIEW',
	REJECTED = 'REJECTED',
	PASSED = 'PASSED',
	IN_PROGRESS = 'IN_PROGRESS',
	CANCELLED = 'CANCELLED',
}

export interface PlaidLinkTokenRequest {}

export interface PlaidComponentConfig {
	onPlaidLinkReady(): void;
	prepareLinkTokenRequest(): CreateLinkTokenRequest;
	beforeIdentityVerificationCreate(): UserIdentityVerificationRequest;
	onUserIdentityVerification(status: UserIdentityVerificationStatus): void;
	beforeIdentityVerificationRetry(): void;
	onUserIdentityVerificationRetry(): void;
}

export interface ProjectActionPlanChildrenDetails extends ProjectActionPlanDetailItem {
	children: any[];
}

export const usMonthYearDateFormat = 'MM/dd/yyyy';
export const dxUsMonthYearDateFormat = 'MM/dd/yyyy';

export interface FilePreviewData {
	file: File;

	filePath: string;
}

export interface FileAcknowledgeData {
	fileLabel: string;

	file: File;

	filePath: string;

	acknoWledgeDocLabel: string;

	showTermsAndConditionLabel: boolean;

	termsAndConditionLabelContent: string;

	cancelDoc: string;

	onAcknowledgeDoc(data: any): void;

	onCancel(data: any): void;
}

export interface UserInfo {
	firstName: string;
	middleName: string;
	lastName: string;
	verificationCode: string;
	phoneNumber: string;
}

export interface Token {
	value: string;
	expirationTime: string;
}

export interface Result<T> {
	isSuccess: boolean;
	message?: string;
	data?: T;
}

export enum KEY_CODE {
	ARROW_UP = 38,
	ARROW_DOWN = 40,
	ARROW_RIGHT = 39,
	ARROW_LEFT = 37,
	BACKSPACE = 8,
	ENTER = 13,
	ALT = 18,
	DIGIT_1 = 49,
	DIGIT_2 = 50,
	DIGIT_3 = 51,
	DIGIT_4 = 52,
	DIGIT_5 = 53,
	DIGIT_6 = 54,
	DIGIT_7 = 55,
	DIGIT_8 = 56,
	DIGIT_9 = 57,
	DIGIT_0 = 48,
}

export interface NotificationAddDialogModel {
	messageBody: string;
	level: string;
	isCreateMode: boolean;
}

export interface UserGroupDialogModel {
	allUsers?: InternalUserItem[];
	isCreateMode?: boolean;
	userGroupAddRequest?: UserGroupAddRequest;
}

export enum InternalPermissionTypeEnum {
	RESOURCE_CENTER_MANAGER = 'ResourceCenter.Manager',
	RESOURCE_CENTER_EDITOR = 'ResourceCenter.Editor',
	RESOURCE_CENTER_USER = 'ResourceCenter.User',
}

export enum S3UploadResponseStatus {
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE',
	RETRY = 'RETRY',
}

export interface AddressInfo {
	name?: string | undefined;
	address?: string | undefined;
	city?: string | undefined;
	state?: string | undefined;
	zip?: string | undefined;
	latitude?: string | undefined;
	longitude?: string | undefined;
	branchWebsiteUrl?: string | undefined;
	country?: string | undefined;
	formatted_address?: string | undefined;
}

export class PresignedUrlFileUploadModel {
	file!: File;
	fileGUID!: string;
	fileVersionGUID!: string;
	createNewFile!: boolean;
	skipVersionUpdate?: boolean = false;
	skipRecordUpdate?: boolean = false;
}

export class PresignedFileDownloadModel {
	fileName!: string;
	presignedUrl!: string;
	fileType!: string;
	file!: File | undefined;
}

export interface CarouselImageModel {
	s3FileGUID?: string;
	imageData: string;
}
